export default __webpack_public_path__ + "static/media/lspditekindo.b8cb18a6.png";